import Modules from "./modules/modules";

new Modules().init();

jQuery(document).ready(function ($) {
	jQuery(".hamburger-menu").on("click", function () {
		$("html, body").animate({ scrollTop: 0 }, 200);
		jQuery(".mobile-side-menu").toggleClass("opened");
		jQuery("body").toggleClass("scroll-disabled");
	});
	jQuery(".hamburger-menu--m").on("click", function () {
		jQuery(".mobile-side-menu").toggleClass("opened");
		jQuery("body").toggleClass("scroll-disabled");
	});

	jQuery(".mobile-menu-items .menu-item-has-children").each(function (index) {
		jQuery(this).append("<div class='show-sub-menu'></div>");
	});

	jQuery(".mobile-menu-items .show-sub-menu").on("click", function () {
		jQuery(this).parent().toggleClass("opened");
	});

	const checkFooter = () => {
		const windowHeight = jQuery(window).height();
		const contentHeight = jQuery("body").height();
		const footerHeight = jQuery("footer").height();

		if (jQuery("footer").hasClass("sticky")) {
			if (windowHeight < contentHeight + footerHeight) {
				jQuery("footer").removeClass("sticky");
			}
		} else {
			if (windowHeight > contentHeight) {
				jQuery("footer").addClass("sticky");
			}
		}
	};

	checkFooter();

	jQuery(window).resize(function () {
		checkFooter();
	});

	jQuery(".remote-form").each(function () {
		if ("" !== $(this).attr("v65remotejs")) {
			vin65remote.form.form(
				$(this).data("website"),
				$(this).data("formname"),
				$(this)
			);
		}
	});

	jQuery(document).on("keyup", ".quantity", function () {
		var $this = jQuery(this);
		$this.val($this.val().replace(/[^\d]/g, ""));
		jQuery(this)
			.closest(".product")
			.find(
				".v65-widgetProduct-addToCart form:first-child .v65-widgetProduct-addToCart-quantity input"
			)
			.val($this.val());
	});

	jQuery(document).on("click", ".product-add-to-cart button", function () {
		if (jQuery(this).closest(".gif-card-info").length) {
			const formNumber = +jQuery(".gift-card-info select")
				.find(":selected")
				.val();
			jQuery(".v65-widgetAddToCart").each(function (index) {
				if (index == formNumber) {
					jQuery(this).submit();
				}
			});
		} else {
			jQuery(this)
				.closest(".product")
				.find(
					".v65-widgetProduct-addToCart form:first-child .add-to-cart"
				)
				.click();
		}
		jQuery(".overlay").addClass("modal-show");
		var str = jQuery(this)
			.closest(".product")
			.find(".product-image")
			.parent()
			.html();
		jQuery(".product-modal-img").html(str);
	});

	jQuery(".product-modal .icon-close").click(function () {
		jQuery(".overlay").removeClass("modal-show");
		jQuery(".product-modal").hide();
	});

	var targetNodes = document.querySelectorAll(
		'[v65remotejs="addToCartForm"]'
	);
	if (targetNodes.length) {
		targetNodes.forEach((target) => {
			new MutationObserver((mutations, observer) => {
				if (document.querySelector(".v65-widgetProduct-addToCart")) {
					observer.disconnect();
					if (
						jQuery(target).find(
							".v65-widgetProduct-addToCart-outOfStockMessage"
						).length > 0 ||
						jQuery(target).find(
							".v65-widgetProduct-addToCart-securityMessage"
						).length > 0
					) {
						jQuery(target)
							.closest(".product-purchase")
							.find(".product-add-to-cart input")
							.hide();
						jQuery(target)
							.closest(".product-purchase")
							.find(".product-add-to-cart button")
							.hide();
						if (
							jQuery(target).find(
								".v65-widgetProduct-addToCart-outOfStockMessage"
							).length > 0
						) {
							jQuery(target)
								.closest(".product-purchase")
								.find(".product-add-to-cart .d-none")
								.removeClass("d-none");
						}
						if (
							jQuery(target).find(
								".v65-widgetProduct-addToCart-securityMessage"
							).length > 0
						) {
							jQuery(target)
								.closest(".product-purchase")
								.find(".product-add-to-cart .message-product")
								.text(
									jQuery(target)
										.find(
											".v65-widgetProduct-addToCart-securityMessage"
										)
										.text()
								)
								.show();
							jQuery(target)
								.closest(".product-purchase")
								.find(".product-add-to-cart .message-product")
								.attr(
									"href",
									jQuery(
										".wd-widgets .winedirect-account a"
									).attr("href")
								);
						}
					}
				}
			}).observe(target, { childList: true, subtree: true });
		});
	}
});
